import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useEffect, useState } from "react";
import { Button } from "rsuite";
import { useTranslation } from "react-i18next";
import { isEmptyVal } from "../../../utils/helpers";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ContentRoutes } from "../../../navigation/NavConstant";
import ViewCompanyProductsModal from "./ViewCompanyProducts";

const ProductBulkImportAction = ({
  companyId,
  checkedKeys,
  setCheckedKeys,
  onBulkImport,
  onDeleteProduct,
  data,
  ...props
}: {
  companyId: number;
  checkedKeys: any;
  setCheckedKeys: Function;
  onDeleteProduct: Function;
  onBulkImport: Function;
  data: any;
}) => {
  const { t } = useTranslation();
  const [openBulkActionNoSelectionModal, setOpenBulkActionNoSelectionModal] =
    useState(false);
  const [openBulkImportModal, setOpenBulkImportModal] = useState(false);
  const [bulkActionMessage, setBulkActionMessage] = useState("");
  const [bulkActionTitle, setBulkActionTitle] = useState("");
  const [openModalByName, setOpenModalByName] = useState("");
  const [loader, setLoading] = useState(true);
  const [dataToImport, setDataToImport] = useState<any>([]);
  const dispatchedCompId = useSelector((state: any) => {
    return state?.actionData?.id;
  });

  useEffect(() => {}, []);

  function bulkImport() {
    if (checkedKeys.length === 0) {
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenBulkImportModal(true);
    let msg = t("CONFIRM_ACTION", {
      action: t("IMPORT").toLowerCase(),
      entity: t("PRODUCT").toLowerCase(),
    });
    var productWithEmptyPrice = "";
    let importData: any[] = [];
    data.forEach(function (item: any) {
      if (checkedKeys.includes(item.id)) {
        importData.push(item);
        if (
          parseFloat(item["tentative_price"]).toFixed(2).toString() == "0.00" ||
          isEmptyVal(item["tentative_price"])
        ) {
          productWithEmptyPrice += item["product_name"] + ", ";
        }
      }
    });
    if (!isEmptyVal(productWithEmptyPrice)) {
      msg +=
        "\n" +
        t("NOTE_PRODUCT_EMPTY_PRICE", {
          product: productWithEmptyPrice.replace(/,\s*$/, ""),
        });
    }
    setBulkActionMessage(msg);
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: t("IMPORT").toLowerCase(),
      })
    );
    setDataToImport(importData);
  }

  return (
    <div className="product-action col-md-8 customer-action">
      <React.Fragment>
        <Link to={ContentRoutes.COMPANIES}>
          <Button appearance="primary" color="blue" type="button">
            {t("BACK")} {t("TO").toLocaleLowerCase()}{" "}
            {t("LIST").toLocaleLowerCase()}
          </Button>
        </Link>
        {UtilityServices.hasPermission("import-product-for-company") && (
          <Button onClick={() => bulkImport()} color="blue" type="button">
            {t("IMPORT")}
          </Button>
        )}
        {UtilityServices.hasPermission("view-company-product") && (
          <Button
            onClick={() => setOpenModalByName("view-imported-products")}
            color="green"
            type="button"
          >
            {t("VIEW")} {t("IMPORTED")} {t("PRODUCTS")}
          </Button>
        )}
      </React.Fragment>

      <AlertModal
        open={openBulkActionNoSelectionModal}
        handleClose={(e: any) => {
          if (e) {
            setOpenBulkActionNoSelectionModal(false);
          }
        }}
        displayText={t("PLEASE_SELECT_RECORD_TO_ACTION")}
        modalTitle={t("PLEASE_SELECT")}
        cancelButton={false}
      />
      <AlertModal
        open={openBulkImportModal}
        handleClose={(e: any) => {
          if (e == true) {
            onBulkImport(dataToImport);
            setOpenBulkImportModal(false);
          } else {
            setDataToImport([]);
            setOpenBulkImportModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />

      {openModalByName === "view-imported-products" && (
        <ViewCompanyProductsModal
          companyId={companyId}
          openModal={true}
          setOpenModal={setOpenModalByName}
          onDeleteProduct={onDeleteProduct}
        />
      )}
    </div>
  );
};

export default ProductBulkImportAction;
